const normalize = (value) =>
  typeof value === "string" ? value.trim().toLowerCase() : value;

export const excludeSelectedOptions = (options, ownValue, excludedValues = [], getValue = (o) => o) => {
  const own = normalize(ownValue);
  const excluded = new Set(
    excludedValues
      .filter((v) => v !== undefined && v !== null && v !== "" && normalize(v) !== own)
      .map(normalize)
  );
  if (!options?.length || excluded.size === 0) return options || [];
  return options.filter((opt) => !excluded.has(normalize(getValue(opt))));
};
